import React, { useState, useContext } from 'react';
import slugify from 'slugify';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';

import { IFilterMenuProps } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenu';
import { IAuctionMappings } from 'src/pages/CatalogPage/Catalog.i';

import { FilterFacetCount } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenuOption/FilterMenuOption.style';
import {
  FilterOptionRadioMobile,
  FiltersMobile,
  FilterButtons,
  FilterFacetButton,
  SessionFilter,
  CaliberTab,
  CaliberTabBackButton,
  FiltersMobileMenuLoadingFloat,
  CollectionsList,
  FiltersMobileModal,
} from 'src/pages/CatalogPage/components/FilterMenu/FiltersMobileMenu/FiltersMobileMenu.style';
import { ModalContentArea } from '@riac/design-system';

import { TextButton } from '@riac/design-system';
import { Spinner } from '@riac/design-system';

import { TabbedNavigation, TabbedNavigationBodyItem } from '@riac/design-system';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { OverlayContainer } from '@react-aria/overlays';


export const FiltersMobileMenu = ({
  facets,
  updateFilter,
  mappings,
  collections,
  searchInput,
  searchBusy,
}: IFilterMenuProps) => {
  const filtersModalOverlayState = useOverlayTriggerState({});
  const sessionFilterModalOverlayState = useOverlayTriggerState({});
  const savedSearchesModalOverlayState = useOverlayTriggerState({});

  const [caliberTabPos, setCaliberTabPos] = useState('left');

  const { gotoAddress, auctionTypeId } = useContext(CatalogContext);

  function changeFilter(slug: string, field: keyof IAuctionMappings) {
    updateFilter(slug, field);
  }

  const hloFilters = mappings.hlo;
  const amCodeFilters = mappings.amcode;

  // tally facet counts for amcodes
  let amCodeLotA = 0;
  let amCodeLotM = 0;
  let amCodeLotI = 0;
  let amCodeLotC = 0;
  if(facets) {
    for(let i = 0; i < Object.keys(facets.amCodeLot).length; i++) {
      const facet = Object.keys(facets.amCodeLot)[i];
      if(facet.indexOf('A') !== -1) {
        amCodeLotA += facets.amCodeLot[facet];
      }
      if(facet.indexOf('M') !== -1) {
        amCodeLotM += facets.amCodeLot[facet];
      }
      if(facet.indexOf('I') !== -1) {
        amCodeLotI += facets.amCodeLot[facet];
      }
      if(facet.indexOf('C') !== -1) {
        amCodeLotC += facets.amCodeLot[facet];
      }
    }
  }

  const fullManuList = mappings.manu
    .map((manu) => {
      const count = facets.manufacturerName[manu.name.trim()] || 0;
      return { ...manu, count };
    })
    .filter((mf) => mf && mf.count > 0 && mf.name !== 'None')
    .sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

  const fullSubCaliberList = mappings.subcaliber
    .map((subcal) => {
      const count = facets.guageCategory[subcal.name.trim()] || 0;
      return { ...subcal, count };
    })
    .filter((sc) => sc && sc.count > 0 && sc.name !== 'N/A')
    .sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

  const fullCaliberList = mappings.caliber
    .map((cal) => {
      const count = facets.guageNum[cal.name.trim()] || 0;
      return { ...cal, count };
    });

  return (
    <FiltersMobile>
      <FilterButtons>
        <TextButton blueText onPress = {() => filtersModalOverlayState.open()}>Filters</TextButton>
        { ( facets.lotNumber )
          && <TextButton blueText onPress = {() => sessionFilterModalOverlayState.open()}>Auction Days</TextButton>
        }
        { ( collections.length > 0 )
          && <TextButton blueText onPress = {() => savedSearchesModalOverlayState.open()}>Collections</TextButton>
        }
      </FilterButtons>
      {filtersModalOverlayState.isOpen
        && <OverlayContainer>
          <FiltersMobileModal
            isOpen
            isDismissable
            showCloseButton
            title='Filters'
            onClose={() => filtersModalOverlayState.close()}
            fullHeight
          >
            <ModalContentArea>
              {searchBusy
                && <FiltersMobileMenuLoadingFloat>
                  <Spinner inverted/>
                </FiltersMobileMenuLoadingFloat>
              }
              <TabbedNavigation>
                {facets.hasBids && auctionTypeId === TIMED_AUCTION_TYPE_ID
                  && <TabbedNavigationBodyItem tabId = 'riacOnTime' tabLabel = 'RIAC On Time'>
                    <FilterOptionRadioMobile
                      value={'All'}
                      key={'hasBids-all'}
                      checked={searchInput.hasBids !== 'false'}
                      onChange={()=>changeFilter('', 'hasBids')}
                      name={'hasBids'}
                    >
                      All
                    </FilterOptionRadioMobile>
                    <FilterOptionRadioMobile
                      value={'false'}
                      key={'hasBids-false'}
                      checked={searchInput.hasBids === 'false'}
                      onChange={()=>changeFilter('hasBids', 'hasBids')}
                      name={'hasBids'}
                    >
                      No Bids <FilterFacetCount>({facets.hasBids.false || 0})</FilterFacetCount>
                    </FilterOptionRadioMobile>
                  </TabbedNavigationBodyItem>
                }
                <TabbedNavigationBodyItem tabId = 'gunType' tabLabel = 'Gun Types'>
                  {hloFilters.map((hlo) => {
                    const count = facets.hlo[hlo.value] || facets.gunType[hlo.value] || 0;
                    const active = searchInput.hlo === hlo.value || (searchInput.hlo === '' && hlo.value === 'All');
                    return (
                      <FilterOptionRadioMobile
                        value={hlo.name}
                        onChange={() => changeFilter(hlo.slug, 'hlo')}
                        name='hlo'
                        checked={active}
                        disabled={false}
                        key={hlo.value}
                      >
                        {hlo.name}
                        {hlo.value !== 'All' && <FilterFacetCount>({count})</FilterFacetCount>}
                      </FilterOptionRadioMobile>
                    );
                  })}
                </TabbedNavigationBodyItem>
                <TabbedNavigationBodyItem tabId = 'amCode' tabLabel = 'Categories'>
                  {amCodeFilters.map((amcode) => {
                    const active = searchInput.amcode === amcode.value || (searchInput.amcode === '' && amcode.value === 'All');
                    let count = 0;
                    switch (amcode.name) {
                      case 'Antique Firearms':
                        count = amCodeLotA;
                        break;
                      case 'Antique Lots':
                        count = facets.amCodeLot['A'];
                        break;
                      case 'Curio & Relic':
                        count = amCodeLotC;
                        break;
                      case 'Class III':
                        count = amCodeLotI;
                        break;
                      case 'Modern Firearms':
                        count = amCodeLotM;
                    }

                    return (
                      <FilterOptionRadioMobile
                        value={amcode.name}
                        onChange={() => changeFilter(amcode.slug, 'amcode')}
                        name='amcode'
                        checked={active}
                        disabled={false}
                        key={amcode.value}
                      >
                        {amcode.name}
                        {amcode.value !== 'All' && <FilterFacetCount>({count})</FilterFacetCount>}
                      </FilterOptionRadioMobile>
                    );
                  })}
                </TabbedNavigationBodyItem>
                <TabbedNavigationBodyItem tabId = 'manu' tabLabel = 'Manufacturers'>
                  <FilterOptionRadioMobile
                    value='All'
                    onChange={() => changeFilter('', 'manu')}
                    name='manu'
                    checked={searchInput.manu === 'All' || searchInput.manu === ''}
                    disabled={false}
                  >
                    All
                  </FilterOptionRadioMobile>
                  {fullManuList.sort((a, b) =>
                    (
                      b.name.toUpperCase() < a.name.toUpperCase()
                    ) ? 1 : (
                        a.name.toUpperCase() < b.name.toUpperCase()
                      ) ? -1 : 0
                  ).map((manu) => {
                    const active = searchInput.manu === manu.value;
                    return (
                      <FilterOptionRadioMobile
                        value={manu.name}
                        onChange={() => changeFilter(manu.slug, 'manu')}
                        name='manu'
                        checked={active}
                        disabled={false}
                        key={manu.value}
                      >
                        {manu.name}
                        <FilterFacetCount>({manu.count})</FilterFacetCount>
                      </FilterOptionRadioMobile>
                    );
                  })}
                </TabbedNavigationBodyItem>
                <TabbedNavigationBodyItem tabId = 'caliber' tabLabel = 'Calibers'>

                  <CaliberTab show={caliberTabPos === 'left'}>
                    <FilterOptionRadioMobile
                      value=''
                      onChange={() => changeFilter('', 'caliber')}
                      name='caliber'
                      checked={searchInput.caliber === ''}
                      disabled={false}
                    >
                      All Calibers
                    </FilterOptionRadioMobile>
                    {fullCaliberList.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0).map((caliber, i) => (
                      <React.Fragment
                        key={`cal__${i}`}
                      >
                        <FilterOptionRadioMobile
                          value={caliber.name}
                          onChange={() => changeFilter(caliber.slug, 'caliber')}
                          name='caliber'
                          checked={caliber.value === searchInput.caliber}
                          disabled={false}
                        >
                          {caliber.name}
                          <FilterFacetCount>({caliber.count})</FilterFacetCount>
                        </FilterOptionRadioMobile>
                        {(caliber.value === searchInput.caliber && searchInput.caliber !== '' && fullCaliberList)
                          && <div>
                            <FilterFacetButton onPress={() => setCaliberTabPos('right')}>
                              Sub Calibers <FaArrowRight/>
                            </FilterFacetButton>
                          </div>
                        }
                      </React.Fragment>
                    ))}
                  </CaliberTab>
                  <CaliberTab show={caliberTabPos === 'right'}>
                    <CaliberTabBackButton onPress={() => setCaliberTabPos('left')}><FaArrowLeft/> Back</CaliberTabBackButton>
                    <h2>Sub Calibers</h2>
                    <FilterOptionRadioMobile
                      value=''
                      onChange={() => changeFilter('', 'subcaliber')}
                      name='subcaliber'
                      checked={searchInput.subcaliber === ''}
                      disabled={false}
                    >
                      All SubCalibers
                    </FilterOptionRadioMobile>
                    {searchInput.caliber && fullSubCaliberList
                      // .filter((facet) => facets.guageNum[facet] > 0)
                      .sort((a, b) => b.count - a.count)
                      .map((subcaliber, i) => {
                        const active = subcaliber.value === searchInput.subcaliber;

                        return (
                          <FilterOptionRadioMobile
                            value={subcaliber.name}
                            name='subcaliber'
                            onChange={() => changeFilter(subcaliber.slug, 'subcaliber')}
                            checked={active}
                            key={`sub__${i}`}
                            disabled={false}
                          >
                            {subcaliber.name} ({subcaliber.count})
                          </FilterOptionRadioMobile>
                        );
                      }
                      )}
                  </CaliberTab>

                </TabbedNavigationBodyItem>
              </TabbedNavigation>
            </ModalContentArea>
          </FiltersMobileModal>
        </OverlayContainer>
      }
      {sessionFilterModalOverlayState.isOpen
        && <OverlayContainer>
          <FiltersMobileModal
            isOpen
            isDismissable
            showCloseButton
            title='Auction Days'
            onClose = { () => sessionFilterModalOverlayState.close()}
            fullHeight
          >
            <ModalContentArea>
              {searchBusy
                && <FiltersMobileMenuLoadingFloat>
                  <Spinner inverted/>
                </FiltersMobileMenuLoadingFloat>
              }
              <SessionFilter>
                {facets.lotNumber
                  && mappings.session.map((session) => {
                    const count = facets.lotNumber[`[${session.startingLot},${session.endingLot}]`];
                    const active
                      = searchInput.session === session.value
                      || (session.value === 'All' && searchInput.session === '');
                    return (
                      <FilterOptionRadioMobile
                        value={session.name}
                        onChange={() => changeFilter(session.slug, 'session')}
                        name='session'
                        checked={active}
                        disabled={false}
                        key={session.slug}
                      >
                        {session.name}
                        {session.value !== 'All' && <FilterFacetCount>({count})</FilterFacetCount>}
                      </FilterOptionRadioMobile>
                    );
                  })}
              </SessionFilter>
            </ModalContentArea>
          </FiltersMobileModal>
        </OverlayContainer>
      }
      {savedSearchesModalOverlayState.isOpen
        && <OverlayContainer>
          <FiltersMobileModal
            isOpen
            isDismissable
            showCloseButton
            title='Collections'
            onClose = { () => savedSearchesModalOverlayState.close() }
            fullHeight
          >
            <ModalContentArea>
              {searchBusy
                && <FiltersMobileMenuLoadingFloat>
                  <Spinner inverted/>
                </FiltersMobileMenuLoadingFloat>
              }
              <CollectionsList>
                <li key={'none'}>
                  <FilterOptionRadioMobile
                    value = 'none'
                    name = 'Collection'
                    checked = {searchInput.savedSearch === ''}
                    disabled = {false}
                    onChange={() => {
                      if(searchInput.savedSearch !== '')
                      {
                        // remove '?' from beginning; split search params on '&'; filter out any savedSearch parameter from before; join params back up
                        const newSearchText = location.search.slice(1).split('&').filter((x) => x.indexOf('savedSearch') === (-1)).join('&');
                        gotoAddress(`${location.pathname}?${newSearchText}`);
                      }
                    }}
                  >
                    None
                  </FilterOptionRadioMobile>
                </li>
                {collections.map((v) => {
                  const active = (searchInput.savedSearch === v.CID);
                  return (
                    <li key={v.Collection}>
                      <FilterOptionRadioMobile
                        value = {v.Collection}
                        name = 'Collection'
                        checked = {active}
                        disabled = {false}
                        onChange={() => {
                          if(!active)
                          {
                            // remove '?' from beginning; split search params on '&'; filter out any savedSearch parameter from before; concat in this savedSearch; join params back up
                            const newSearchText = location.search.slice(1).split('&').filter((x) => x.indexOf('savedSearch') === (-1)).concat(`savedSearch=${slugify(v.Collection)}`).join('&');
                            gotoAddress(`${location.pathname}?${newSearchText}`);
                          }
                        }}
                      >
                        {v.Collection}
                      </FilterOptionRadioMobile>
                    </li>
                  );
                })}
              </CollectionsList>
            </ModalContentArea>
          </FiltersMobileModal>
        </OverlayContainer>
      }
    </FiltersMobile>
  );
};
